import type { PropsWithChildren } from 'react';
import { motion } from 'framer-motion';
import styled from 'styled-components';
import type { TreeViewTransition } from '@frameio/vapor';
import { theme } from '@frameio/vapor-theme';
import { TRANSITION } from './SubTreeContainer';

export const TreeChildrenWrapper = ({
  transition,
  children,
}: PropsWithChildren<{
  transition?: TreeViewTransition;
}>) => (
  <StyledChildrenWrapper key="children">
    <motion.div
      animate={{
        transform:
          transition === 'open' || !transition
            ? 'translateY(0%)'
            : 'translateY(-100%)',
      }}
      initial={{
        transform:
          transition === 'open' ? 'translateY(-100%)' : 'translateY(0%)',
      }}
      transition={TRANSITION}
    >
      {children}
    </motion.div>
  </StyledChildrenWrapper>
);

const StyledChildrenWrapper = styled.div`
  overflow: hidden;
  padding-bottom: ${theme.spaces[20]};
`;
